import { inventoryAdjustmentReasonIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const deleteInventoryAdjustmentReason = {
  name: "deleteInventoryAdjustmentReason" as const,
  input: z.object({ id: inventoryAdjustmentReasonIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
